import React from 'react';
import ServicePageLayout, { FeatureGrid, ServiceCTA } from './ServicePageLayout';
import { getService } from './serviceData';

const service = getService('managed-it-smb');

const included = [
  { title: 'Device Management', desc: 'Provisioning, updates, and monitoring across every workstation and device.' },
  { title: 'Network Monitoring', desc: '24/7 visibility into your network so issues are caught before you feel them.' },
  { title: 'On-Site Support', desc: 'Local hands when something physical needs fixing, not just a phone tree.' },
  { title: 'Remote Helpdesk', desc: 'Fast remote support for your team’s day-to-day tech questions and tickets.' },
  { title: 'Security Patching', desc: 'Regular patching and updates to keep systems protected and compliant.' },
  { title: 'Hardware Procurement', desc: 'We source, configure, and deploy the right hardware so you don’t have to.' },
];

const whoFor = [
  'Restaurants',
  'Law offices',
  'Dental clinics',
  'Retail',
  'Creative studios',
];

const ManagedItSmb = () => (
  <ServicePageLayout
    service={service}
    h1="Managed IT for Small Businesses"
    subhead="Your tech, handled. Monthly."
  >
    <p className="service-intro">
      Proactive monthly IT support for small businesses across New York and New Jersey. We manage
      your infrastructure (remote and on-site) so you can run your business instead of
      troubleshooting it.
    </p>

    <FeatureGrid heading="What's Included" features={included} />

    <section className="service-section">
      <h2>Who It's For</h2>
      <ul className="service-stack-list">
        {whoFor.map((who) => (
          <li key={who}>{who}</li>
        ))}
      </ul>
    </section>

    <section className="service-section">
      <h2>Pricing</h2>
      <div className="service-callout">
        <p>
          <strong>Starting at $X/month per location</strong>, contact us for a custom quote based
          on your team size, locations, and hardware.
        </p>
      </div>
    </section>

    <section className="service-section">
      <h2>Why Tavernix</h2>
      <div className="service-feature-grid">
        <div className="custom-card">
          <h3>Local NY / NJ Presence</h3>
          <p>A regional team that can actually show up on-site when you need hands-on help.</p>
        </div>
        <div className="custom-card">
          <h3>One Team, Hardware & Software</h3>
          <p>The same people who manage your devices also build and integrate your software.</p>
        </div>
        <div className="custom-card">
          <h3>Full Automation Ready</h3>
          <p>
            Plug in Destiny, Scouter, and Bridget to automate calls, lead generation, and customer
            engagement on top of your managed stack.
          </p>
        </div>
      </div>
    </section>

    <section className="service-section">
      <div className="service-callout">
        <p>
          Need on-site hardware support too? {' '}
          <a href="https://techcarenynj.com" target="_blank" rel="noreferrer">Visit Tavernix Tech →</a>
        </p>
      </div>
    </section>

    <ServiceCTA
      heading="No more IT headaches."
      blurb="Tell us about your business and we'll put together a custom quote."
      label="Get a Custom Quote"
      href="mailto:info@tavernix.io?subject=Managed%20IT%20Custom%20Quote"
    />
  </ServicePageLayout>
);

export default ManagedItSmb;
